import * as React from 'react';
import { ImageContext } from './ImageContext.esm.js';

var LargeImageContext = function (_a) {
    var children = _a.children;
    return (React.createElement(ImageContext.Provider, { value: { size: 'large' } }, children));
};

export { LargeImageContext };
//# sourceMappingURL=LargeImageContext.esm.js.map
